module.exports = __webpack_public_path__ + "static/media/become-img-2-1.53ab2f78.png";